import {VisualModalComponent} from "../../../../../../../../components/visual/modal/VisualModalComponent";
import {Component} from "../../../../../../../../../sedestral/framework/interface/component/Component";
import {ICommunityModel} from "../../../../../../../../../models/community/ICommunityModel";
import {Resources} from "../../../../../../../../../resources/Resources";
import {Network} from "../../../../../../../../../network/Network";
import {numberPrice} from "../../../../../../../../../sedestral/framework/utilities/NumberPrice";
import {ICommunityIndexationOverviewIncoming} from "../../../../../../../../../models/community/seo/indexation/ICommunityIndexationOverviewIncoming";
import {ICommunityIndexationPackIncoming} from "../../../../../../../../../models/community/seo/indexation/ICommunityIndexationPackIncoming";
import {CommunityIndexationService} from "../../../../../../../../../services/community/indexation/CommunityIndexationService";
import {SiteCreditService} from "../../../../../../../../../services/site/credit/SiteCreditService";
import {VisualInputStatesComponent} from "../../../../../../../../components/visual/input/states/VisualInputStatesComponent";
import {ButtonsSaveComponent} from "../../../../../../../../components/global/buttons/save/ButtonsSaveComponent";
import {OfferCreditsModalComponent} from "../../../../../offer/credits/modal/OfferCreditsModalComponent";
import * as s from "./community-page-indexation-recharge.scss";

export class CommunityPageIndexationRechargeModalComponent extends VisualModalComponent {

    public community: ICommunityModel;
    public overview: ICommunityIndexationOverviewIncoming;
    public onRecharged: () => void;

    public packsContainer: Component;
    public freeInput: VisualInputStatesComponent;
    public freePrice: Component;
    public buttons: ButtonsSaveComponent;

    public packCards: { card: Component, credits: number, price: number, priceLocal: number }[];
    public selectedCredits: number;
    public selectedPrice: number;      // EUR (gating/manquant)
    public selectedPriceLocal: number; // converti (prefill top-up = local, le modal ne manipule que du local)
    public unitCents: number;          // EUR — gate instantané du montant libre (formule identique au back priceForCredits)

    constructor(community: ICommunityModel, overview: ICommunityIndexationOverviewIncoming, onRecharged: () => void) {
        super();
        this.community = community;
        this.overview = overview;
        this.onRecharged = onRecharged;
        this.packCards = [];

        const packs = overview.packs || [];
        const last = packs.length > 0 ? packs[packs.length - 1] : {credits: 1, priceCents: 0, priceCentsLocal: 0};
        this.unitCents = last.credits > 0 ? last.priceCents / last.credits : 0;
        const defaultPack = packs.find(pack => pack.popular) || (packs.length > 0 ? packs[0] : undefined);
        this.selectedCredits = defaultPack != undefined ? defaultPack.credits : 0;
        this.selectedPrice = defaultPack != undefined ? defaultPack.priceCents : 0;
        this.selectedPriceLocal = defaultPack != undefined ? defaultPack.priceCentsLocal : 0;

        this.name = Resources.t("words.indexationRechargeTitle");
        this.modalStyle = "width:640px;max-width:95vw;";
        this.autoResize = true;

        this.freeInput = new VisualInputStatesComponent({
            type: "number",
            noLabel: true,
            minNumber: overview.freeMinCredits,
            maxNumber: overview.freeMaxCredits,
            placeholder: Resources.r("words.indexationRechargeFreePlaceholder", {min: overview.freeMinCredits, max: overview.freeMaxCredits})
        });
        this.buttons = new ButtonsSaveComponent({hideCancelButton: true, themeBlack: true, saveText: Resources.t("words.indexationRechargePay")});

        //language=HTML
        this.modalTemplate = `
            <div class="${s.componentIndexationRecharge}">
                <div class="${s.explain}">${Resources.t("words.indexationRechargeDesc")}</div>
                <div class="${s.packs}"></div>
                <div class="${s.freeRow}">
                    <div class="${s.freeLabel}">${Resources.t("words.indexationRechargeFree")}</div>
                    <div class="${s.freeInputHost}">${this.draw(this.freeInput)}</div>
                    <div class="${s.freePrice}"></div>
                </div>
                <div class="${s.footer}">
                    ${this.draw(this.buttons)}
                </div>
            </div>
        `;
    }

    commit() {
        super.commit();

        this.packsContainer = this.el(s.packs);
        this.freePrice = this.el(s.freePrice);

        (this.overview.packs || []).forEach(pack => this.renderPackCard(pack));

        this.freeInput.onKeyUp(() => this.onFreeInput(), 200);
        this.buttons.onSave = () => this.doPay();
    }

    renderPackCard(pack: ICommunityIndexationPackIncoming) {
        //language=HTML
        const card = this.packsContainer.append(`
            <div class="${s.packCard} ${pack.popular ? s.popularCard : ''}">
                ${pack.popular ? `<div class="${s.popular}">${Resources.t("words.popular")}</div>` : ''}
                <div class="${s.packSelect}"></div>
                <div class="${s.packCredits}">${Resources.r("words.indexationRechargeCredits", {count: pack.credits})}</div>
                <div class="${s.packPrice}">${numberPrice(pack.priceCentsLocal, Resources.currency, false)}</div>
            </div>
        `);

        const entry = {card: card, credits: pack.credits, price: pack.priceCents, priceLocal: pack.priceCentsLocal};
        this.packCards.push(entry);

        card.onClick(() => this.selectPack(entry));

        if (pack.credits === this.selectedCredits) {
            card.addClass(s.selected);
        }
    }

    selectPack(entry: { card: Component, credits: number, price: number, priceLocal: number }) {
        this.selectedCredits = entry.credits;
        this.selectedPrice = entry.price;
        this.selectedPriceLocal = entry.priceLocal;
        this.packCards.forEach(packCard => packCard.card.removeClass(s.selected));
        entry.card.addClass(s.selected);
        this.freeInput.setValue("");
        this.freePrice.setText("");
    }

    async onFreeInput() {
        const credits = parseInt(this.freeInput.getValue());
        if (isNaN(credits) || credits < this.overview.freeMinCredits || credits > this.overview.freeMaxCredits) {
            this.freePrice.setText("");
            return;
        }
        this.packCards.forEach(packCard => packCard.card.removeClass(s.selected));
        this.selectedCredits = credits;
        this.selectedPrice = Math.round(credits * this.unitCents); // EUR (gate) — instantané, formule identique au back
        this.freePrice.setText("…");

        // prix LOCAL affiché = calculé par le back (source unique IndexationCreditPack.priceForCredits), pas d'estimation front
        const pack = await CommunityIndexationService.getPriceForCredits(this.community.id, credits, this);
        if (pack && parseInt(this.freeInput.getValue()) === credits) {
            this.selectedPriceLocal = pack.priceCentsLocal;
            this.freePrice.setText(numberPrice(pack.priceCentsLocal, Resources.currency, false));
        }
    }

    async doPay() {
        if (this.selectedCredits <= 0 || this.selectedPrice <= 0) {
            return;
        }

        this.buttons.setLoadingAndInactive();
        const balance = await SiteCreditService.getBalance(this);
        const available = balance ? balance.balance : 0;
        const availableLocal = balance ? balance.balanceLocal : 0;

        if (available < this.selectedPrice) {
            // gate en € (vérité) → recharge Stripe du manquant PUIS on enchaîne la conversion en crédits indexation.
            // (sans ça, le paiement Stripe ne faisait que recharger le solde € sans acheter les crédits indexation)
            // prefill du top-up en devise locale (le modal ne manipule que du local)
            this.buttons.remLoadingAndInactive();
            const modal = new OfferCreditsModalComponent(this.selectedPriceLocal - availableLocal);
            let chained = false;
            modal.onCreditsPurchased = () => {
                if (chained) {
                    return;
                }
                chained = true;
                modal.close();
                // le solde € vient d'être crédité → conversion directe (jamais re-ouvrir le top-up = pas de double paiement)
                this.buttons.setLoadingAndInactive();
                this.doConvert();
            };
            modal.screenRender();
            return;
        }

        await this.doConvert();
    }

    async doConvert() {
        const success = await CommunityIndexationService.convert(this.community.id, this.selectedCredits, this);
        if (success) {
            Network.router.static.components.notifications.notify(Resources.t("words.indexationRechargeDone"), undefined, 3000, "success");
            this.onRecharged();
            await this.close();
        } else {
            this.buttons.remLoadingAndInactive();
        }
    }
}
